import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import i18n from './core/i18n'

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)

createApp(App).use(router).use(i18n).use(pinia).mount('#app')
